import React from 'react';

import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function PartnerAccountsTable({
  items,
  loading,
  pageSize,
  totalRows,
  onRowClick,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      tableLayout="fixed"
      onRow={(record) => {
        if (onRowClick) {
          return {
            onDoubleClick: () => onRowClick(record),
          };
        }

        return null;
      }}
      onChange={onChange}
    />
  );
}

export { PartnerAccountsTable };
